import { apiFetch } from "core/api/base";

export function * deletePlaygroundGroup ({ namespace, groupId }) {
	return yield apiFetch({
		endpoint: `/v1/playground/group/${namespace}/${groupId}`,
		method: "DELETE",
		authenticated: true
	});
}
